import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M19.782 7.086L11.62 1.502c-.984-.674-2.257-.674-3.24 0L.218 7.086c-.228.156-.286.467-.13.695s.468.287.695.13l1.218-.833V17c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2V7.078l1.218.833a.5006.5006 0 0 0 .695-.131.5009.5009 0 0 0-.131-.695zM7 18v-5c0-.551.449-1 1-1h4c.551 0 1 .449 1 1v5H7zm10-1c0 .551-.449 1-1 1h-2v-5c0-1.105-.895-2-2-2H8c-1.105 0-2 .895-2 2v5H4c-.551 0-1-.449-1-1V6.394l5.944-4.067c.641-.439 1.469-.438 2.111 0l5.944 4.067V17z',
  ],
  height: 20,
  width: 20,
});
